import { render, staticRenderFns } from "./StarButton.vue?vue&type=template&id=64c1ed84"
import script from "./StarButton.vue?vue&type=script&lang=js"
export * from "./StarButton.vue?vue&type=script&lang=js"
import style0 from "./StarButton.vue?vue&type=style&index=0&id=64c1ed84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports